import { useAppTheme } from "../../useAppTheme";
import FlatProgress from "./FlatProgress";
import type { AudioPlayerState } from "./index";

type Props = {
	progress: number;
	state: AudioPlayerState;
	isEnded: boolean;
};

const PlayerFlat = ({ progress, state, isEnded }: Props) => {
	const theme = useAppTheme();
	return (
		<FlatProgress
			progress={progress}
			activeColor={theme.colors.primary}
			trackColor={theme.colors.outline}
			stopColor={
				state === "disabled" ? theme.colors.outline : theme.colors.primary
			}
			showPlayhead={
				!isEnded &&
				(state === "inProgress" || state === "paused" || state === "playOnce")
			}
			showEndStop={!isEnded && state !== "locked"}
		/>
	);
};

export default PlayerFlat;
